import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import i18n from "../../../../i18nextInitiator";
import { Typography } from "@material-ui/core";
import { updateOrder } from "../../../../actions/actionCreators";
import ButtonWithLoading from "../../ButtonWithLoading";
import SelectFloor from "../SelectFloor";
import Divider from "../../Divider";
import { getUpdateData } from "../../../../actions/apiCallActions";
import HeavyItems from "../HeavyItems";
import StopTime from "../StopTime";
import WorkerSelector from "../WorkerSelector";

const t = i18n.getFixedT("fa", "general");

/**
 * styles.
 * @type {(props?: any) => ClassNameMap<"paper"|"cardTypo"|"root">}
 */
const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0 20px",
    maxWidth: 600,
    margin: "0 auto",
    "& > *": {
      margin: ".8rem 0",
    },
    "& button": {
      boxShadow: "unset",
    },
    "& *:focus": {
      outline: 0,
    },
  },
  paper: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: ".3rem",
    border: `solid 1px ${theme.palette.primary.border}`,
    padding: ".5rem",
    width: "100%",
    zIndex: 1,
    boxShadow: "none",
    minHeight: "4rem",
  },
  tabSelected: {
    color: "white",
  },
  tabIndicator: {
    height: "100%",
    zIndex: -1,
    borderRadius: 8,
    // boxShadow: `0 0 5px 2px rgba(25, 39, 131, 0.24)`
  },
  serviceSubtitle: {
    fontWeight: 900,
  },
  divider: {
    border: "solid .5px #d8d8d8",
    width: "100%",
    opacity: "0.5",
  },
  box: {
    margin: ".3rem 0",
  },
}));

const mapStateToProps = (state) => ({ ...state.order });

/**
 * Update Order Page.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const UpdateOrderPage = (props) => {
  const classes = useStyles();

  const { order: { car_id } = {} } = props;

  /**
   * filters the element with count and sorts the array based on view property.
   * @type {*[]}
   */
  const [services, setServices] = useState([2, 1, 3]);

  useEffect(() => {
    getUpdateData(props.match.params);
  }, []);

  return (
    <>
      <Grid container className={classes.root}>
        <Paper className={classes.paper}>
          <Tabs
            value={car_id}
            variant="fullWidth"
            indicatorColor="primary"
            classes={{ indicator: classes.tabIndicator }}
          >
            {services.map((number, index) => {
              return (
                <Tab
                  value={number}
                  classes={{ selected: classes.tabSelected }}
                  key={number}
                  label={
                    <>
                      <Typography>{t(`services.${index}.title`)}</Typography>
                      <Typography className={classes.serviceSubtitle}>
                        {t(`services.${index}.subtitle`)}
                      </Typography>
                    </>
                  }
                />
              );
            })}
          </Tabs>
        </Paper>

        <HeavyItems />

        <Divider />

        <WorkerSelector />

        <SelectFloor />

        <StopTime />

        <ButtonWithLoading
          text={t("update-order")}
          action={updateOrder}
          loading={props.preOrdering}
        />
      </Grid>
    </>
  );
};
export default withRouter(connect(mapStateToProps)(UpdateOrderPage));
